import { Check } from 'lucide-react';

// Static, abbreviated examples for the brand motif, never live verification data.
const records = [
  { label: 'STATE / 01', digest: '7a3f9c2e', previous: 'origin record' },
  { label: 'STATE / 02', digest: 'b8d1046a', previous: 'prev 7a3f9c2e' },
  { label: 'EVIDENCE', digest: 'e6c9270f', previous: 'prev b8d1046a' },
];

export const DigestMotif = ({ id, showCaption = true }) => (
  <div className="digest-motif mono" data-testid={`${id}-digest-motif`}>
    <p className="digest-heading" data-testid={`${id}-digest-heading`}>STATE HISTORY <span>/ DIGESTS</span></p>
    <ol className="digest-records" aria-label="Illustrative digest-linked state history" data-testid={`${id}-digest-records`}>
      {records.map((record, index) => (
        <li className={`digest-record ${index === 2 ? 'digest-evidence' : ''}`} key={record.digest} data-testid={`${id}-digest-record-${index + 1}`}>
          <span className="digest-junction" aria-hidden="true">{index === 2 && <Check size={9} strokeWidth={1.5} />}</span>
          <span className="digest-label" data-testid={`${id}-digest-label-${index + 1}`}>{record.label}</span>
          <code className="digest-value" data-testid={`${id}-digest-value-${index + 1}`}>{record.digest}</code>
          <span className="digest-previous" data-testid={`${id}-digest-previous-${index + 1}`}>{record.previous}</span>
        </li>
      ))}
    </ol>
    {showCaption && <p className="digest-disclaimer" data-testid={`${id}-digest-disclaimer`}>Illustrative abbreviated digests · not live telemetry</p>}
  </div>
);